if (!customElements.get('smx-purchase-dock')) {
  customElements.define('smx-purchase-dock', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.source = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.primary = this.source?.querySelector('.product__block--buy_buttons .product-form__submit');
      if (!this.primary) return;
      this.controller = new AbortController();
      this.button = this.querySelector('[data-dock-button]');
      this.price = this.querySelector('[data-dock-price]');
      const options = { signal: this.controller.signal };
      this.sync = () => {
        const current = this.source.querySelector('.product__block--buy_buttons .product-form__submit');
        if (!current) { this.hidden = true; return; }
        this.primary = current;
        const rect = current.getBoundingClientRect();
        const mobile = matchMedia('(max-width: 1023.98px)').matches;
        const visible = rect.bottom > 0 && rect.top < innerHeight;
        this.hidden = !mobile || visible;
        this.button.disabled = current.disabled || current.getAttribute('aria-disabled') === 'true';
        this.button.querySelector('.btn__text').textContent = current.classList.contains('addToCart') ? this.dataset.configureLabel : this.dataset.optionsLabel;
        const price = this.source.querySelector('[id^="price-"]');
        if (price && this.price.innerHTML !== price.innerHTML) this.price.innerHTML = price.innerHTML;
        document.body.classList.toggle('smx-purchase-dock-visible', !this.hidden);
      };
      this.button.addEventListener('click', () => {
        if (!this.primary || this.primary.disabled) return;
        if (this.primary.classList.contains('addToCart')) {
          this.primary.click();
        } else {
          this.primary.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
          this.primary.focus({ preventScroll: true });
        }
      }, options);
      this.observer = new IntersectionObserver(this.sync, { threshold: [0, 1] });
      this.observer.observe(this.primary);
      this.mutations = new MutationObserver(this.sync);
      this.mutations.observe(this.source, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled','aria-disabled'] });
      window.addEventListener('resize', this.sync, options);
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.observer?.disconnect(); this.mutations?.disconnect();
      document.body.classList.remove('smx-purchase-dock-visible');
    }
  });
}
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.smx-v3 .collection').forEach(collection => {
      if (collection.dataset.smxToolbarReady) return;
      const toolbar = collection.querySelector(':scope > .sticky-element');
      if (!toolbar) return;
      collection.dataset.smxToolbarReady = 'true';
      const observer = new ResizeObserver(() => collection.style.setProperty('--smx-toolbar-height', `${Math.ceil(toolbar.getBoundingClientRect().height)}px`));
      observer.observe(toolbar);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
